import { BackgroundColors, BorderColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const Divider = styled.div<{ margin?: string }>`
	margin: ${({ margin }) => margin && margin};
	border-bottom: 1px solid ${BorderColors.Secondary};
`;

const CodeWrapper = styled.div`
	padding: 8px 10px;
	border-radius: ${BorderRadius.LG}px;
	background-color: ${BackgroundColors.Primary};
	width: fit-content;
	box-shadow: 0px 1px 2px 0px #1018280d;
	border: 1px solid ${BackgroundColors.BluePrimary};
	margin-bottom: 16px;
`;

const ModalBody = styled.div`
	margin: -10px -24px;
	height: calc(100% + 20px);
`;

const ModalFooterContainer = styled.div``;

const FirstColumn = styled.div`
	height: 100%;
	padding: 24px;
	border-right: 1px solid ${BorderColors.Secondary};
	background-color: ${BackgroundColors.PrimaryAlt};
`;

const BoxesWrapper = styled.div`
	width: calc(100% + 24xpx);
	height: calc(100% - 100px);
	overflow-y: auto;
	padding-right: 24px;
`;

const SecondColumn = styled.div`
	padding: 24px;
	height: 100%;
	overflow-y: auto;
`;

const Box = styled.div`
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
	border: 1px solid ${BorderColors.Secondary};
	padding: 24px;
	max-height: 152px;
	width: 100%;
	border-radius: ${BorderRadius.XL}px;
`;

const IconBox = styled.div<{ backgroundColor?: string; boxShadow?: string; border?: string }>`
	width: 48px;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: ${BorderRadius.LG}px;
	background-color: ${({ backgroundColor }) => backgroundColor || "transparent"};

	box-shadow: ${({ boxShadow }) => boxShadow || ""};
	border: ${({ border }) => `1px solid ${border}` || "none"};
`;

export { ModalBody, ModalFooterContainer, Divider, CodeWrapper, FirstColumn, Box, IconBox, BoxesWrapper, SecondColumn };
